import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { JobStatusModalProps } from 'components/modals';
import { ROUTES } from 'config';
import { useJobsContext } from 'store/jobs';
import { surveysKeys } from 'store/surveys';
import { usePredefinedToasts } from 'utils/Toast';
import { routerHistory } from 'utils/router-history';
import { openTrainingGenerationProgressToast } from './training-generation-progress-toast.component';

export const useTrainingGenerationJobStatusProps = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const predefinedToasts = usePredefinedToasts();
  const { removeInProgressJob } = useJobsContext();

  return (jobId: string): Omit<JobStatusModalProps, 'closeModal'> => ({
    jobId,
    queue: 'aiTrainingQueue',
    refetchInterval: 3000,
    title: t('trainings.generate.in_progress.title'),
    description: t('trainings.generate.in_progress.description'),
    actions: (closeModal) => [
      {
        variant: 'neutral-outline',
        label: t('trainings.generate.actions.minimize'),
        onClick: () => {
          openTrainingGenerationProgressToast(jobId);
          closeModal();
        },
      },
    ],
    onSuccess: (job, closeModal) => {
      removeInProgressJob(jobId);
      queryClient.invalidateQueries(surveysKeys.lists);
      closeModal();
      predefinedToasts.success.added();

      if (job.output?.surveyId) {
        routerHistory.push(
          ROUTES.surveys.training.details.replace(':id', job.output.surveyId),
        );
      }
    },
    onError: (job, closeModal) => {
      removeInProgressJob(jobId);
      toast.error(job.error || t('errors.genericErrorMessage'));
      closeModal();
    },
  });
};
